import { graphql } from "@opensea/graphql"
import { TransferFlowReviewItemsFragment } from "../TransferFlowReviewItems/TransferFlowReviewItems.fragment"
import { TransferFlowTimeline_itemFragment } from "../TransferFlowTimeline/TransferFlowTimeline.fragment"

export const TransferFlowReview_itemFragment = graphql(
  `
    fragment TransferFlowReview_item on Item {
      ...TransferFlowReviewItems
      ...TransferFlowTimeline_item
    }
  `,
  [TransferFlowReviewItemsFragment, TransferFlowTimeline_itemFragment],
)
